import {Component, OnDestroy, OnInit} from '@angular/core';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";
import {CookieService} from 'ngx-cookie-service';
@Component({
  selector: 'app-oppo-gulf2021',
  templateUrl: './oppo-gulf2021.component.html',
  styleUrls: ['./oppo-gulf2021.component.scss']
})
export class OppoGulf2021Component implements OnInit,OnDestroy {
  loading = false
  constructor(public globalService:GlobalService , private titleService: Title,    private cookieService: CookieService) {
    this.titleService.setTitle('Reno 6 PUBG Mobile Cup')

  }


  ngOnInit(): void {
    this.cookieService.set('arabhardware','oppo-gcc')
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
        this.globalService.langChosen = localStorage.getItem('language');
      } else {
        this.globalService.customLang = require('./lang/en.json');
      }
  }

}
  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.globalService.langChosen = value;
      this.globalService.customLang = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);

    }
  }
  ngOnDestroy() {
    this.cookieService.delete('arabhardware')
  }
}
